
import Vue from "vue";

export default Vue.extend({
  inheritAttrs: false,
  props: ['loading', 'success', 'closeable', 'requiredCustom', 'value'],
  watch: {
    success: {
      handler() {
        if (this.success) {
          this.$attrs.success = !!this.success;
          this.$attrs['success-messages'] = this.success ? [this.success] : [];
        } else {
          this.$attrs.success = false;
          this.$attrs['success-messages'] = [];
        }
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    const requiredFn = (value, label) => {
      return !!value && value !== 0 || (label ? label + ' ' : '') + this.$t("APP.REQUIRED")
    }
    return {
      requiredFn,
      val: this.value,
    }
  },
  created() {
    this.$nextTick(() => {
      if (this.$refs.input.$children[1]) {
        this.$refs.input.$children[1].$el.setAttribute('tabindex', 1);
      }
    });
  }
})
